import * as actionTypes from './selfDiagnosisActionTypes';

const initialState = {
  loading: false,
  symptoms: [],
  stepOneSelectedDiseases: [],
  result: [],
  symptomsForStepTwo: [],
  activeState: 0,
  percentage: '',
};

function reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.SET_STEP_ONE_SELECTED_DISEASE:
      return {
        ...state,
        stepOneSelectedDiseases: action.data,
      };
    case actionTypes.GET_SYMPTOMS:
      return {
        ...state,
        loading: true,
      };
    case actionTypes.GET_SYMPTOMS_SUCCESS:
      return {
        ...state,
        loading: false,
        symptoms: action.data.result,
      };
    case actionTypes.GET_SYMPTOMS_FAILED:
      return {
        ...state,
        loading: false,
      };
    case actionTypes.DIAGNOSE_DISEASE:
      return {
        ...state,
        loading: true,
      };
    case actionTypes.DIAGNOSE_DISEASE_SUCCESS_GOTO_STEP_TWO:
      return {
        ...state,
        loading: true,
        symptomsForStepTwo: action.data.symptoms,
        percentage: action.data.percentage,
      };
    case actionTypes.DIAGNOSE_DISEASE_SUCCESS_WITH_RESULTS:
      return {
        ...state,
        loading: true,
        result: action.data.disease,
        percentage: action.data.percentage,
      };
    case actionTypes.DIAGNOSE_DISEASE_FAILED:
      return {
        ...state,
        loading: false,
      };
    case actionTypes.SET_DISEASE:
      return {
        ...state,
        result: action.data,
      };
    case actionTypes.RESET_STATE:
      return {
        ...state,
        loading: false,
        stepOneSelectedDiseases: [],
        result: [],
        symptomsForStepTwo: [],
        activeState: 0,
        percentage: '',
      };
    case actionTypes.SET_ACTIVE_STATE:
      return {
        ...state,
        activeState: action.data,
      };
    default:
      return state;
  }
}

export default reducer;
